import React, { FunctionComponent } from "react";
import { PersonalTaxFormTitle } from "../PersonalTaxFormTitle";
import { Trans } from "@lingui/macro";
import { VoorafbetalingenForm } from "./VoorafbetalingenForm";
import { TaxCodesForm } from "./TaxCodesForm";
import { InputField } from "components/fields/InputField";

export interface Props {}

export const AangiftecodesForm: FunctionComponent<Props> = () => {
  return (
    <div className="main">
      <div id="tab_codelist">
        <PersonalTaxFormTitle icon="list-ol">
          <Trans>Voorafbetalingen</Trans>
        </PersonalTaxFormTitle>
        <VoorafbetalingenForm />
        <PersonalTaxFormTitle>
          <Trans>Aangiftecodes</Trans>
        </PersonalTaxFormTitle>
        <TaxCodesForm />
      </div>
      <div className="e1optimize" style={{ clear: "both", marginLeft: "28px" }}>
        <InputField type="checkbox" id="c3003" name="c3003" className="off" />
        <label className="checkboxlabel" htmlFor="c3003">
          <Trans>Kapitaalaflossingen optimaliseren</Trans>
        </label>
      </div>
    </div>
  );
};

AangiftecodesForm.displayName = "AangiftecodesForm";
